import { combineReducers } from "redux";

import { usersReducer } from './usersReducer';
import { workspaceReducer } from "./workspaceReducer";
import { storyboardsReducer } from "./storyboardsReducer";
import { templateReducer } from "./templateReducer";
import { fontReducer } from "./fontReducer";
import { pageReducer } from "./pageReducer";
import { mediaReducer } from "./mediaReducer";
import { contentReducer } from "./contentReducer";
import { contentCardsReducer } from "./contentCardsReducer";

import { integrationsReducer } from './integrations/integrationsReducer';
import { brandKitReducer } from "./brandKit/brandKitReducer";

import { userManagementReducer } from "./userManagementReducer";
import { userRolesReducer } from "./userRolesReducer";
import { liveElementsReducer } from "./liveelementsReducer";
import { gatingReducer } from "./gatingReducer";

import { LOGOUT_USER } from 'constants/actionTypes';
import { storyboardsListReducer } from "./storyboardListReducer";
import { formsReducer } from "./forms/formsReducer";
import { formFieldsReducer } from "./formFieldsReducer";
import { gatingConfigurationsReducer } from "./gatingConfigurationsReducer";
import { leadsReducer } from "./leadsReducer";
import { fieldsReducer } from "./fields/fieldsReducer";
import { versionsReducer } from "./versionReducer";
import { aliasReducer } from "./aliases";
import { hubReducer } from "./paperfliteReducer";
import { lockReducer } from "./lockReducer";
import { journeyReducer } from "./journeyReducer";
import { paletteReducer } from "./paletteReducer";
import { variableReducer } from "./variableReducer";
import { personalizationReducer } from "./personalization";
import { promptEditorReducer } from "./promptEditorReducer";

const appReducer = combineReducers({
  users: usersReducer,
  workspaces: workspaceReducer,
  storyboards: storyboardsReducer,
  aliases: aliasReducer,
  templates: templateReducer,
  fonts: fontReducer,
  forms: formsReducer,
  formFields: formFieldsReducer,
  pages: pageReducer,
  lead: leadsReducer,
  media: mediaReducer,
  brandKit: brandKitReducer,
  content: contentReducer,
  journey: journeyReducer,
  contentCards: contentCardsReducer,
  integrations: integrationsReducer,
  paperflite: hubReducer,
  userManagement: userManagementReducer,
  userRoles: userRolesReducer,
  liveElements: liveElementsReducer,
  storyboardList: storyboardsListReducer,
  personalization: personalizationReducer,
  gatings: gatingReducer,
  gatingConfigurations: gatingConfigurationsReducer,
  fields: fieldsReducer,
  versions: versionsReducer,
  lock: lockReducer,
  palette: paletteReducer,
  variables: variableReducer,
  promptEditor: promptEditorReducer
})

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;